import { redirect } from "react-router-dom";
import { validateToken } from "utils/checkAuthorization";
import { getUserDetails } from "utils/localStorageServices";

/**
 * Loader applied to all protected app/admin routes.
 * - Redirects unauthenticated users to /login
 * - Redirects users who have not completed onboarding to /onboarding
 */
export function protectedRouteLoader() {
  const userDetails = getUserDetails();
  const isAuthenticated = userDetails?.token && validateToken();

  if (!isAuthenticated) {
    return redirect("/login");
  }

  // Only redirect when we explicitly know the user hasn't completed onboarding.
  // Treat null (missing flag) as trusted — it means either the user is an existing
  // onboarded user from before this feature shipped, or localStorage was cleared.
  const onboardingComplete = localStorage.getItem("onboardingComplete");
  if (onboardingComplete === "false") {
    return redirect("/onboarding");
  }

  return null;
}
